export const SET_WORKSPACE_LOADER = "SET_WORKSPACE_LOADER"
export const SET_WORKSPACE_COMMENT_LOADER = "SET_WORKSPACE_COMMENT_LOADER"
export const SET_WORKSPACE_DATA = "SET_WORKSPACE_DATA"
export const SET_WORKSPACE_DETAIL = "SET_WORKSPACE_DETAIL"
export const SET_WORKSPACE_ACTIVITY = "SET_WORKSPACE_ACTIVITY"
export const SET_WORKSPACE_PAGE = "SET_WORKSPACE_PAGE"
